class Countdown extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      countdown: '[data-countdown]',
      days: '[data-countdown-days]',
      hours: '[data-countdown-hours]',
      minutes: '[data-countdown-minutes]',
      seconds: '[data-countdown-seconds]',
    };

    this.data = {
      countdownEnd: 'countdownEnd',
    };

    this.days = this.querySelector(this.selectors.days);
    this.hours = this.querySelector(this.selectors.hours);
    this.minutes = this.querySelector(this.selectors.minutes);
    this.seconds = this.querySelector(this.selectors.seconds);

    this.endDateUTC = new Date(this.dataset[this.data.countdownEnd]).getTime();
    
    this.timer = setInterval(this.iterateCountdown, 1000);
  }

  iterateCountdown = () => {
    const currentDate = new Date();
    const currentDateUTC = currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000;
    const timeLeft = this.endDateUTC - currentDateUTC;

    if (timeLeft <= 0) {
      clearInterval(this.timer);
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.days.innerText = days < 10 ? '0' + days : days;
    this.hours.innerText = hours < 10 ? '0' + hours : hours;
    this.minutes.innerText = minutes < 10 ? '0' + minutes : minutes;
    this.seconds.innerText = seconds < 10 ? '0' + seconds : seconds;
  }
}

customElements.define('countdown-component', Countdown);
